import { useAppSelector } from 'hooks/reduxHooks'
import { getFunnelFeatures, getFunnelEvaluationMetadata, FunnelEvaluationMetadata } from 'checkout/selectors/funnel'

export function useFunnelFeature(feature: keyof App.FunnelFeatureToggles): boolean {
  return useAppSelector(getFunnelFeatures)[feature]
}

/**
 * Hook to get the funnel evaluation metadata (ruleId, ruleName, outcome).
 * Useful for debugging, analytics, or displaying which rule was applied.
 */
export function useFunnelEvaluationMetadata(): FunnelEvaluationMetadata {
  return useAppSelector(getFunnelEvaluationMetadata)
}
